import AddIcon from '@/common/assets/icons/add.svg?react';
import RefreshIcon from '@/common/assets/icons/refreshIcon.svg?react';
import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

type ImageActionsProps = {
  onOpenCompletingImages: () => void;
  onRetakeImages?: () => void;
};

const ImageActions = ({
  onOpenCompletingImages,
  onRetakeImages,
}: ImageActionsProps) => {
  return (
    <Flex
      mt={40}
      border="1px solid"
      borderColor="purple-primary"
      borderRadius={8}
      height={48}
      justifyContent="space-between"
    >
      <Button variant="text" color="primary" onClick={onOpenCompletingImages}>
        <Typography textStyle="b4" color="purple-primary">
          تصاویر تکمیلی
        </Typography>
        <Box mx={6}>
          <AddIcon width={16} height={16} fill={token('colors.purple-2')} />
        </Box>
      </Button>

      <Box
        width="1px"
        height="24px"
        backgroundColor="purple-primary"
        my={10}
      ></Box>

      <Button variant="text" color={'common'} onClick={onRetakeImages}>
        <Typography textStyle="b4" color="black-3">
          تصویربرداری مجدد
        </Typography>
        <Box mx={6}>
          <RefreshIcon color={token('colors.black-3')} width={12} height={12} />
        </Box>
      </Button>
    </Flex>
  );
};

export default ImageActions;
